import axios from 'axios';
import { URLS } from './Urls';
import { refreshToken } from './Refresh_Token';
import { getUserDetails } from '../Components/Utils/Functions';


const API = axios.create({
    baseURL: URLS.BASE_URL,
    timeout: 250000,
    headers: URLS.CLIENT_ID ? { "Client-Id": URLS.CLIENT_ID } : undefined,
});

//Project API
const PROJECTAPI = axios.create({
    baseURL: URLS.BASE_URL,
})

const AUTHAPI = axios.create({
    baseURL: URLS.BASE_URL,
});

API.interceptors.request.use(
    async (config) => {
        const user = getUserDetails()
        // const session = token;
        const token = user?.access_token;

        if (token) {
            config.headers = {
                ...config.headers,
                Authorization: user ? `Bearer ${user?.access_token ?? " "}` : undefined
            };
        }
        return config;
    },
    (error) => Promise.reject(error)
);
// Response interceptor for API calls
API.interceptors.response.use(
    (response) => {
        console.log(response.data)
        return response;
    },
    async function (error) {
        console.log(error);
        const originalRequest = error.config;
        if (error.response?.status === 403 || (error.response?.status === 401 && !originalRequest._retry)) {
            originalRequest._retry = true;
            const access_token = await refreshToken();
            // CONTACTAPI.defaults.headers.common['Authorization'] = access_token;
            originalRequest.headers = {
                ...originalRequest.headers,
                Authorization: `Bearer ${access_token}`
            };
            return axios(originalRequest);
        }
        return Promise.reject(error);
    }
);


export { API, AUTHAPI, PROJECTAPI };
